// import firebase from 'firebase';
import firebase from "firebase";
import { db } from "../init/firebase.init";

class MomentService {
  constructor() {
    window.console.log("Creating momentservice");
    this.momentsCollection = db.collection("moments");
  }

  getMoments(userId, date) {
    if (!userId) {
      return Promise.resolve([]);
    }
    let query = this.momentsCollection.orderBy("dateTime", "asc").where("userId", "==", userId);

    if (date) {
      const compareDate = date instanceof Date ? new Date(date) : new Date(date.start);
      compareDate.setHours(0, 0, 0);
      const endDate = date instanceof Date ? new Date(compareDate) : new Date(date.end);
      endDate.setDate(endDate.getDate() + 1);
      query = query.where("dateTime", ">=", compareDate).where("dateTime", "<", endDate);
    }

    const res = query.get().then(result =>
      !result || result.empty
        ? []
        : result.docs.map(d => {
            const obj = d.data();
            obj.id = d.id;
            MomentService.mapFields(obj);
            return obj;
          })
    );
    return res;
  }

  getMomentById(momentId) {
    const docRef = this.momentsCollection.doc(momentId);
    return docRef.get().then(result => {
      if (result && !result.empty && result.exists) {
        const obj = result.data();
        obj.id = result.id;
        MomentService.mapFields(obj);
        return obj;
      }
      return null;
    });
  }

  static mapFields(moment) {
    if (!moment) {
      return;
    }
    if (moment.dateTime && moment.dateTime.toDate) {
      moment.dateTime = moment.dateTime.toDate();
    }
  }

  saveMoment(moment) {
    if (!moment || !moment.userId) {
      return Promise.resolve([]);
    }
    const data = moment;
    const collection = this.momentsCollection;
    let mediaFile = null;
    if (data.media && typeof data.media !== "string") {
      mediaFile = data.media;
      data.media = null;
    }

    // create uploadFilePromise
    const storageRef = firebase.storage().ref();
    const metadata = {
      contentType: mediaFile ? mediaFile.type : ""
    };
    function uploadFilePromise() {
      return mediaFile === null
        ? Promise.resolve()
        : new Promise(resolve => {
            storageRef
              .child(`images/${data.userId}/${data.id}.${mediaFile.name.split(".").pop()}`) // .split.pop for extension
              .put(mediaFile, metadata)
              .then(snapshot => snapshot.ref.getDownloadURL())
              .then(url => {
                // window.console.log('Uploaded', snapshot.totalBytes, 'bytes.');
                window.console.log(url);
                data.media = url;
                window.console.log("File available at", url);
                resolve();
              });
          });
    }

    function addDocumentPromise() {
      if (!data.id) {
        delete data.id;
        return new Promise(resolve =>
          collection.add(data).then(docRef => {
            window.console.log("setting data id after add");
            data.id = docRef.id;
            resolve();
          })
        );
      }
      return Promise.resolve();
    }

    let dataId = data.id;
    const isNew = !dataId;
    return addDocumentPromise()
      .then(uploadFilePromise)
      .then(() => {
        dataId = data.id;
        delete data.id;
        return !isNew || mediaFile ? collection.doc(dataId).set(data) : Promise.resolve();
      })
      .catch(error => {
        window.console.warn("some ting wong");
        window.console.warn(error);
      })
      .then(() => {
        window.console.log("restoring data id");
        data.id = dataId;
      });
  }

  deleteMoment(momentId) {
    return this.momentsCollection.doc(momentId).delete();
  }
}

export default new MomentService();
